import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Navbar from "components/navbars/AdminNavbar.js";
import Sidebar from "components/sidebars/Sidebar.js";
import HeaderStats from "components/headers/HeaderStats.js";
import FooterAdmin from "components/footers/FooterAdmin.js";
import Baixar from "views/motorista/Baixar";
import Finalizar from "views/motorista/Finalizar";

export default function Admin() {
  // Primeiro carregamento: define flag e recarrega uma vez
  useEffect(() => {
    const firstLoad = localStorage.getItem("firstLoad");
    if (!firstLoad || Number(firstLoad) === 0) {
      localStorage.setItem("firstLoad", "1");
      window.location.reload();
    }
  }, []);

  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) {
    return <Redirect to="/auth/login" />;
  }

  return (
    <div className="flex h-screen bg-blueGray-100">
      

      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Navbar fixa no topo */}
       

        {/* Conteúdo principal */}
        <main className="flex-1 overflow-auto mt-16 p-4 md:p-8">
          {/* Estatísticas de cards */}
         

          {/* Área de rotas internas */}
          <div className="mt-6">
            <Switch>
              <Route path="/motorista/v1/baixar" exact component={Baixar} />
              <Route path="/motorista/v1/finalizar" exact component={Finalizar} />
              <Redirect from="/motorista" to="/motorista/v1/baixar" />
            </Switch>
          </div>
        </main>

        <FooterAdmin />
      </div>
    </div>
  );
}
